// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__-SVPc","checkboxCol":"Table_checkboxCol__13QrP","emailCol":"Table_emailCol__1yZl6","actionCol":"Table_actionCol__s-nLe"};